import { render, staticRenderFns } from "./paper-upload-in-folder.html?vue&type=template&id=6d83c688&scoped=true&"
import script from "./paper-upload-in-folder.js?vue&type=script&lang=js&"
export * from "./paper-upload-in-folder.js?vue&type=script&lang=js&"
import style0 from "./paper-upload-in-folder.scss?vue&type=style&index=0&id=6d83c688&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d83c688",
  null
  
)

export default component.exports